






















































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import DrawerWidthMixin from '../../logic/helpers/DrawerWidthMixin'
import CenteredColumnLayout from '../CenteredColumnLayout.vue'
import EmptyData from '../EmptyData/EmptyData.vue'
import PageTitle from '../PageTitle.vue'
import FlowActionsModal from './AddNewFlowActions/FlowActionsModal.vue'
import FlowPageTitleButtons from './FlowPageTitleButtons.vue'
import FlowsListLink from './FlowsListLink.vue'
import { AddNewFlowAction, FlowItem, FlowsListConfig } from './types'

@Component({
  components: {
    FlowActionsModal,
    FlowsListLink,
    FlowPageTitleButtons,
    PageTitle,
    EmptyData,
    CenteredColumnLayout
  },
  data() {
    return {
      AddNewFlowAction
    }
  }
})
export default class FlowsList extends DrawerWidthMixin {
  @Prop() config!: FlowsListConfig

  @Prop() flowPageSubtitle!: typeof Vue

  searchInput = ''

  flows: Array<{ key: string, title: string, link: string }> = []

  currentFlow: { key: string, title: string, link: string } | null = null

  linkIsOpen = false

  isLoading = false

  flowActionsModal = false

  currentAction: AddNewFlowAction = AddNewFlowAction.Create

  activeFlow: null | FlowItem = null

  get searchResults() {
    if (!this.searchInput.length) {
      return this.flows
    } else {
      return this.flows.filter(f => f.title.trim().toLowerCase().includes(this.searchInput.trim().toLowerCase()))
    }
  }

  openFlowActionsModal(action: AddNewFlowAction):void {
    this.flowActionsModal = true;
    this.currentAction = action;
  }

  selectFlow(flow: { key: string, title: string, link: string }, ): void {
    if (this.currentFlow) {
      if (this.currentFlow.key === flow.key) {
        this.currentFlow = null
        this.linkIsOpen = false
      } else {
        this.currentFlow = flow
        this.linkIsOpen = true
      }
    } else {
      this.currentFlow = flow
      this.linkIsOpen = true
    }
  }

  editFlow(flow_key: string): void {
    this.config.goToFlow(flow_key)
  }

  copyFlow(flow: FlowItem):void {
    this.openFlowActionsModal(AddNewFlowAction.Copy);

    this.activeFlow = flow
  }

  removeFlow(flow_key: string): void {
    const remove = () => {
      this.config.removeFlow(flow_key)
        .then(() => {
          const index = this.flows.findIndex((f) => f.key === flow_key)

          if (index !== -1) {
            this.flows.splice(index, 1)
          }
        })
    }

    this.$confirm({
      centered: true,
      title: this.$t('remove_flow_warn_title').toString(),
      content: this.$t('remove_flow_warn_text').toString(),
      okText: this.$t('accept').toString(),
      okType: 'danger',
      cancelText: this.$t('reject').toString(),
      onOk: remove
    })

  }

  exportFlow(key: string): void {
    window.open(this.config.exportFlowLink(key))
  }

  created(): void {
    this.isLoading = true

    this.config.getFlows()
      .then((flows) => this.flows = flows)
      .finally(() => this.isLoading = false)
  }
}
